import { alpha, type Theme } from '@mui/material/styles';

export const buttonStyles = {
  textTransform: 'none',
  fontWeight: 600,
};

export const countPillStyles = {
  minWidth: 24,
  px: 1,
  lineHeight: '20px',
  textAlign: 'center',
  borderRadius: '999px',
  backgroundColor: '#26272F',
  border: '1px solid rgb(54, 56, 67)',
  color: 'text.secondary',
  fontSize: 12,
  fontWeight: 600,
};

export const teamRowStyles = {
  px: 2,
  py: 2,
  cursor: 'pointer',
  transition: 'background-color 120ms ease',
  '&:not(:last-of-type)': {
    borderBottom: '1px solid',
    borderColor: 'divider',
  },
  '&:hover': {
    backgroundColor: 'action.hover',
  },
};

export const teamIconStyles = {
  width: 40,
  height: 40,
  flexShrink: 0,
  borderRadius: '.5rem',
  backgroundColor: '#26272F',
  border: '1px solid rgb(54, 56, 67)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#B5B7C8',
  fontSize: 20,
};

export const detailIconStyles = {
  ...teamIconStyles,
  width: 52,
  height: 52,
  borderRadius: '.6rem',
  fontSize: 26,
};

export const backButtonStyles = {
  mb: 2,
  px: 1,
  color: 'text.secondary',
  textTransform: 'none',
  fontWeight: 500,
  '&:hover': {
    color: 'text.primary',
    backgroundColor: 'transparent',
  },
};

export const memberRowStyles = {
  px: 2,
  py: 1.5,
  gap: 2,
  transition: 'background-color 120ms ease',
  '&:not(:last-of-type)': {
    borderBottom: '1px solid',
    borderColor: 'divider',
  },
  '&:hover': {
    backgroundColor: 'action.hover',
  },
};

export const roleChipStyles = {
  height: 18,
  fontSize: 10.5,
  fontWeight: 500,
  color: 'text.secondary',
  backgroundColor: 'transparent',
  border: '1px solid',
  borderColor: 'divider',
  '& .MuiChip-label': { px: 0.75 },
};

export const selectStyles = {
  minWidth: 136,
  fontSize: 14,
  backgroundColor: '#1B1D24',
  '& .MuiSelect-select': { py: 0.75 },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgb(54, 56, 67)' },
};

export const menuItemStyles = {
  py: 1,
  px: 1.5,
  mx: 0.5,
  borderRadius: 1,
};

export const dangerHoverStyles = {
  color: 'text.secondary',
  '&:hover': {
    color: 'error.light',
  },
};

export const dialogPaperStyles = {
  backgroundImage: 'none',
  border: '1px solid',
  borderColor: 'divider',
};

export const dialogHeaderStyles = {
  px: 2.5,
  pt: 2.5,
  pb: 2,
};

export const dialogCloseStyles = {
  color: 'text.secondary',
  mt: '-2px',
  mr: '-4px',
};

export const dialogFooterStyles = {
  px: 2.5,
  py: 1.75,
};

export const candidateListStyles = {
  height: 336,
  overflowY: 'auto',
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgba(255, 255, 255, 0.14) transparent',
  '&::-webkit-scrollbar': { width: 10 },
  '&::-webkit-scrollbar-track': { background: 'transparent' },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(255, 255, 255, 0.14)',
    borderRadius: 8,
    border: '3px solid transparent',
    backgroundClip: 'content-box',
  },
  '&::-webkit-scrollbar-thumb:hover': { backgroundColor: 'rgba(255, 255, 255, 0.24)' },
};

export const candidateRowStyles = {
  px: 2.5,
  py: 1.25,
  cursor: 'pointer',
  userSelect: 'none',
  transition: 'background-color 120ms ease',
  '&:not(:last-of-type)': {
    borderBottom: '1px solid',
    borderColor: 'divider',
  },
  '&:hover': {
    backgroundColor: 'action.hover',
  },
};

export const candidateSelectedStyles = {
  backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.08),
  '&:hover': {
    backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.12),
  },
};

export const checkCircleStyles = {
  width: 20,
  height: 20,
  flexShrink: 0,
  borderRadius: '50%',
  border: '1.5px solid',
  borderColor: 'divider',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#fff',
  transition: 'all 120ms ease',
};

export const checkCircleSelectedStyles = {
  backgroundColor: 'primary.main',
  borderColor: 'primary.main',
};
